import React from 'react';

function DocumentTypeField({ value, maxLength, data }) {
  if (!value) return <>-</>;

  if (maxLength && typeof value === 'string' && value.length > maxLength) {
    return <>{value.substr(0, maxLength)}...</>;
  }

  return <>{data.softwareLabel ? `${value} - ${data.softwareLabel}` : value}</>;
}

export default DocumentTypeField;
